import http from '../../plugins/axios';

export default {

    /** == 榜单配置 == */
    queryGainsBlackList(){
        return http.get({
            url : '/admin/list/gainsBlackList',
        })
    },

    queryPopularityList(){
        return http.get({
            url : '/admin/list/popularityList',
        })
    },

    saveGainsBlankList(data) {
        return http.post({
            url: '/admin/list/gains/black/list',
            data,
            dataType: 'form'
        })
    },

    savePopularityList(data) {
        return http.post({
            url: '/admin/list/popular/list',
            data,
            dataType: 'form'
        })
    }
}
